import { render, staticRenderFns } from "./BudgetsListMentee.vue?vue&type=template&id=712f6a41&"
import script from "./BudgetsListMentee.vue?vue&type=script&lang=js&"
export * from "./BudgetsListMentee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports